import { map } from 'lodash';
import lookerApi from '../services/looker-api';

export const LOOK_REQUEST = 'LOOK_REQUEST';
export const LOOK_SUCCESS = 'LOOK_SUCCESS';
export const LOOK_ERROR = 'LOOK_ERROR';

const requestLook = (id, filters) => ({
  id,
  filters,
  type: LOOK_REQUEST
});

const loadLook = ({ id, url, blocked }) => ({
  type: LOOK_SUCCESS,
  id,
  url,
  blocked
});

const errorLook = ({ error, status }) => ({
  type: LOOK_ERROR,
  error,
  status
});

export const getLookEmbed = async (id, lookMeta, filters) => {
  try {
    const embed = await lookerApi.fetchLook(id, lookMeta, filters);

    return {
      id,
      url: embed.url,
      blocked: embed.blocked
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getLookerEmbedsForPage = (
  pageConfig,
  filters
) => async dispatch => {
  const { looks } = pageConfig;

  try {
    map(looks, async (lookMeta, id) => {
      dispatch(requestLook(id, filters));
      const x = await getLookEmbed(id, lookMeta, filters);
      return dispatch(loadLook(x));
    });
  } catch (error) {
    dispatch(errorLook(error));
  }
};
